const initializeProductUsageTabs = (root = document) => {
  root.querySelectorAll('[data-pp-product-usage]').forEach((section) => {
    if (section.dataset.ppUsageReady === 'true') return;

    section.dataset.ppUsageReady = 'true';

    const tabs = section.querySelectorAll('.tab-btn');
    const panels = section.querySelectorAll('.tab-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-selected', 'false');
        });

        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach((panel) => panel.classList.remove('active'));
        section.querySelector(`[data-tab-panel="${tab.dataset.tab}"]`)?.classList.add('active');
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeProductUsageTabs(), { once: true });
} else {
  initializeProductUsageTabs();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeProductUsageTabs(event.target);
});
